import axios from 'axios';
// import qs from "qs";
// axios.create({
// 	// baseURL: location.origin + '/okr', // 公共接口-生产
// 	baseURL: 'http://gzjzyxh.tooge.cn/api/home', // 公共接口-本地
// 	timeout: 30 * 1000, // 超时时间单位是ms
// 	headers: {
// 		"Content-Type": "application/json;charset=UTF-8",
// 	},

// })
const service = axios.create({
    timeout: 60000
});
service.interceptors.request.use(
	config => {
        // if(config.url=='/apply'){
        //     config.url = '/asdasdfsdf'

        //     console.log(config.data)
        // }else{
            (config.method === 'post'  || config.method === 'put' )?
            config.data = {
                ...config.data
            } :
			config.params = {
				...config.data
			};
        // }

		let development = process.env.NODE_ENV == 'development' ? true : false;
		if(development){
			// config.baseURL = 'http://localhost:82/api/home'
            config.baseURL = 'https://gzsrqxh.cn/api/home'
		}else{
			config.baseURL = '/api/home'
		}
		const token = 'Bearer ' + localStorage.getItem("TOKEN"); //这里取token之前，需要先拿到token,存一下
		if (token) {
			// config.params = { 'token': token } //如果要求携带在参数中
			// config.headers.Authorization = '5fb94a47-0904-4368-819f-0d0c7f534a6a'; //如果要求携带在请求头中
			config.headers.Authorization = token; //如果要求携带在请求头中
		}

		config.headers['Content-Type'] = "application/json;charset=UTF-8";
		config.timeout = 1800 * 1000; // 超时时间单位是ms
        return config
	},
	err => {
		// console.error('axios request 请求出错：', err)
		return Promise.reject(err)
	}
)
service.interceptors.response.use(
	response => {
		let data = response.data.data|| {}
		if (response && data) {
			if (data && (data['code'] === "201")) {
				//登录失效
			}
		}
		return Promise.resolve(data)
	},
	err => {
		// console.log(err.response.data.message)
		// console.error(err)
		// let res = {
		// 	success: false,
		// 	message: '系统错误，请重试！'
		// }
		return Promise.reject(err.response.data.message)
	}
)
export default service
